import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import AdminLayout from './components/layout/AdminLayout';
import ProtectedRoute from './components/layout/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import VenueApproval from './pages/VenueApproval';
import CommissionManagement from './pages/CommissionManagement';
import Payouts from './pages/Payouts';
import Analytics from './pages/Analytics';
import Reports from './pages/Reports';
import ClosingPosition from './pages/ClosingPosition';
import BookingDetailsReport from './pages/BookingDetailsReport';
import PaymentReconciliation from './pages/PaymentReconciliation';
import DuprIntegration from './pages/DuprIntegration';
import Settings from './pages/Settings';
import OpenPlays from './pages/OpenPlays';
import CreateOpenPlay from './pages/CreateOpenPlay';
import EditOpenPlay from './pages/EditOpenPlay';
import OpenPlayDetail from './pages/OpenPlayDetail';
import OpenPlayOrganizerApplications from './pages/OpenPlayOrganizerApplications';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: { borderRadius: '10px', background: '#333', color: '#fff', fontSize: '14px' },
            success: { iconTheme: { primary: '#22c55e', secondary: '#fff' } },
            error: { iconTheme: { primary: '#ef4444', secondary: '#fff' } },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="venues" element={<VenueApproval />} />
            <Route path="venues/pending" element={<VenueApproval />} />
            <Route path="venues/:venueId/manage" element={<VenueApproval />} />
            <Route path="openplays" element={<OpenPlays />} />
            <Route path="openplays/new" element={<CreateOpenPlay />} />
            <Route path="openplays/:id/edit" element={<EditOpenPlay />} />
            <Route path="openplays/:id" element={<OpenPlayDetail />} />
            <Route path="open-play-organiser-applications" element={<OpenPlayOrganizerApplications />} />
            <Route path="commissions" element={<CommissionManagement />} />
            <Route path="payouts" element={<Payouts />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="reports" element={<Reports />} />
            <Route path="reports/closing-position" element={<ClosingPosition />} />
            <Route path="reports/booking-details" element={<BookingDetailsReport />} />
            <Route path="reports/payment-reconciliation" element={<PaymentReconciliation />} />
            <Route path="dupr" element={<DuprIntegration />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
